//SHIFT_CONFLICT
export const SHIFT_CONFLICT_REQUEST = "SHIFT_CONFLICT_REQUEST";
export const SHIFT_CONFLICT_SUCCESS = "SHIFT_CONFLICT_SUCCESS";
export const SHIFT_CONFLICT_FAIL = "SHIFT_CONFLICT_FAIL";

//BULK_SHIFT_ASSIGN
export const BULK_SHIFT_ASSIGN_REQUEST = "BULK_SHIFT_ASSIGN_REQUEST";
export const BULK_SHIFT_ASSIGN_SUCCESS = "BULK_SHIFT_ASSIGN_SUCCESS";
export const BULK_SHIFT_ASSIGN_FAIL = "BULK_SHIFT_ASSIGN_FAIL";
